import { render, staticRenderFns } from "./editAddress.vue?vue&type=template&id=09d93a87&scoped=true"
import script from "./editAddress.vue?vue&type=script&lang=js"
export * from "./editAddress.vue?vue&type=script&lang=js"
import style0 from "./editAddress.vue?vue&type=style&index=0&id=09d93a87&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d93a87",
  null
  
)

export default component.exports